<template>
  <div class="page">
    <div class="header-section">
      <div class="head-context">
        <div>
          <p class="weight">Changxin Lan</p>
          <p>
            <span class="weight">Titile/Position:</span> PhD candidate
          </p>
        </div>
        <div>
          <div class="weight">Affiliation:</div>
          <div>
            Institute of Reproductive and Child Health, School of Public
            Health,<br />
            Peking University, Beijing 100191, P.R. China
          </div>
        </div>
        <div>
          <span class="weight">Websiute: </span>
          <a href="https://www.researchgate.net/profile/Lan-Changxin" target="_blank" class="blue">https://www.researchgate.net/profile/Lan-Changxin</a>
        </div>
        <div>
          <span class="weight">Email: </span>
          <span class="blue">lancx_pku@foxmail.com </span>
        </div>
      </div>
      <div class="img">
        <img class="head" :src="img" alt="" />
      </div>
    </div>
    <div class="section">
      <div class="weight">Brief introduction:</div>
      <div class="content">
        I received my Bachelor’s degree (Preventive Medicine) and Master’s degree (Epidemiology and Health Statistics) from the School of Public Health, Peking University (2014-2021). During master's degree, I mainly studied the effect of air pollution on blood pressure of women of childbearing age and its potential mechanism. Currently, I'm pursuing my PhD in Epidemiology and Health Statistics at Peking University, focusing on environmental and reproductive health. Meanwhile, I am interested in learning R, Python and HTML languages.
      </div>
    </div>
    <div class="section">
      <div class="weight">Representative papers:</div>
      <p>
        1. <span class="weight">Lan C</span>, Liu Y, Li Q, et al. Internal metal(loid)s are potentially involved in the association between ambient fine particulate matter and blood pressure: A repeated-measurement study in north China. Chemosphere. 2021; 267:129146.
      </p>
      <p>
        2. Chen J, <span class="weight">Lan C</span>, An H, Jin Y, Li Q, Ge S, Yu Y, Shen G, Pan B, Xu Y, Ye R, Li Z, Wang B. Potential interference on the lipid metabolisms by serum copper in a women population: A repeated measurement study. Sci Total Environ. 2021 Mar 15;760:143375.
      </p>
      <p>
        3. Sun HZ, Yu P, <span class="weight">Lan C</span>, Wan MWL, Hickman S, Murulitharan J, Shen H, Yuan L, Guo Y, Archibald AT. Cohort-based long-term ozone exposure-associated mortality risks with adjusted metrics: A systematic review and meta-analysis. The Innovation, 2022 Apr 20;3(3):100246.
      </p>
      <p>
        4. Fang M, Hu L, Chen D, Guo Y, Liu J, <span class="weight">Lan C</span>, Gong J, Wang B. Exposome in human health: Utopia or wonderland? The Innovation, 2021 Oct 6;2(4):100172.
      </p>
      <p>
        5. Ren M, Jia X, Shi J, Yan L, Li Z, <span class="weight">Lan C</span>, Chen J, Li N, Li K, Huang J, Wu S, Lu Q, Li Z, Wang B, Liu J. Simultaneous analysis of typical halogenated endocrine disrupting chemicals and metal(loid)s in human hair. Sci Total Environ. 2020 May 20;718:137300.
      </p>
      <p>
        6. Li M, Zhuang L, Zhang G, <span class="weight">Lan C</span>, Yan L, Liang R, Hao C, Li Z, Zhang J, Lu Q, Wang B. Association between exposure of light rare earth elements and outcomes of in vitro fertilization-embryo transfer in North China. Sci Total Environ. 2021 Mar 25;762:143106.
      </p>
      <p>
        7. Ren M, Pei R, Jiangtulu B, Chen J, Xue T, Shen G, Yuan X, Li K, <span class="weight">Lan C</span>, Chen Z, Chen X, Wang Y, Jia X, Li Z, Rashid A, Prapamontol T, Zhao X, Dong Z, Zhang Y, Zhang L, Ye R, Li Z, Guan W, Wang B. Contribution of Temperature Increase to Restrain the Transmission of COVID-19. The Innovation, 2021 Feb 28;2(1):100071.
      </p>
      <p>
        8. Li K, Wang B, Yan L, Jin Y, Li Z, An H, Ren M, Pang Y, <span class="weight">Lan C</span>, Chen J, Zhang Y, Zhang L, Ye R, Li Z, Ren A. Associations between blood heavy metal(loid)s and serum heme oxygenase-1 in pregnant women: Do their distribution patterns matter? Environ Pollut. 2021 Oct 1;286:117249.
      </p>
      <p>
        9. Wang X, Gao M, Tan Y, Li Q, Chen J, <span class="weight">Lan C</span>, Jiangtulu B, Wang B, Shen G, Yu Y, Li Z. Associations of Dietary Exposure to Organochlorine Pesticides from Plant-Origin Foods with Lipid Metabolism and Inflammation in Women: A Multiple Follow-up Study in North China. Bull Environ Contam Toxicol. 2021 Aug;107(2):289-295.
      </p>
      <p>
        10.	Wang X, Gao M, Wang B, Tan Y, Guo Y, Li Q, Ge S, <span class="weight">Lan C</span>, Chen J, Jiangtulu B, Li Z, Yu Y. Risk of dietary intake of organochlorine pesticides among the childbearing-age women: A multiple follow-up study in North China. Ecotoxicol Environ Saf. 2021 Aug 16;224:112607.
      </p>
    </div>
  </div>
</template>
<script>
import img from '@/assets/people/lcx.jpg';
export default {
  data() {
    return {
      img
    };
  },
  methods: {},
};
</script>
<style scoped lang="scss">
.page {
  overflow: auto;
  padding: 20px 30px;
  text-align: left;
  font-size: $webpage-base-font-size;
}
.header-section {
  display: flex;
}
.head-context {
  display: flex;
  flex-direction: column;
  gap: 18px
}
.head {
  height: 200px;
  margin-left: 160px;
}
p {
  word-break: break-word;
  overflow: hidden;
  text-align: left;
  line-height: $line-height-x-large;
  margin-bottom: 0;
}
.content {
  word-break: break-word;
  overflow: hidden;
  text-align: left;
  line-height: $line-height-x-large;
}
.weight {
  font-weight: 600
}
.section {
  margin-top: 20px;
  padding-right: 25px;
}
.blue {
  color: $blue-light-1
}
.img {
  display: flex;
  align-items: center;
}
@media screen and (max-width: 600px) {
  .header-section {
    display: flex;
    flex-direction: column;
  }
  .head {
    margin-left: 0;
    margin-top: 18px
  }
}
</style>
